var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.111115 4C0.111115 1.79086 1.90198 0 4.11111 0H14.265C16.4741 0 18.265 1.79086 18.265 4V14C18.265 16.2091 16.4741 18 14.265 18H4.11111C1.90197 18 0.111115 16.2091 0.111115 14V4ZM10.1966 9.99145C10.1966 10.5485 9.74504 11 9.18804 11C8.63103 11 8.17949 10.5485 8.17949 9.99145L8.17949 5.00855C8.17949 4.45154 8.63103 4 9.18804 4C9.74504 4 10.1966 4.45154 10.1966 5.00855L10.1966 9.99145ZM9.18804 12C8.63103 12 8.17949 12.4477 8.17949 13C8.17949 13.5523 8.63103 14 9.18804 14C9.74504 14 10.1966 13.5523 10.1966 13C10.1966 12.4477 9.74504 12 9.18804 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1cb62d8508c595dbafd38b1fb2f1827d.svg";
export { ForwardRef as ReactComponent };